<template>
    
    <div style="background-color: white;">
        <div v-if="convocatoriaEncontrada">
        <h1 class="page-title letraDelTitulo enMayusculas col-12">{{nombreConvocatoria}}</h1>
            <div class="container caja-principal" >
    <div class="caja-contenedora-formulario">
        <div class="pestanas">
            <button class="btn boton-pestana" :class="(mostrarInformacion)?'btn-success':'btn-secondary' " @click="mostrarInformacion=true">Información </button>
            <button class="btn boton-pestana" :class="(mostrarInformacion)?'btn-secondary':'btn-success' " @click="mostrarInformacion=false" v-if="camposDelFormulario.find(c => c.tipo==6)!= undefined">Documentos </button>
        </div>
        <div class="pestanas">
            <h4 style="color: rgb(228, 3, 3)">En caso de dudas o aclaraciones, podrá comunicarse al teléfono 449-979-20-96 en un horario de  08:30 a 15:30 horas.</h4>
        </div>
        <div v-show="mostrarInformacion">
        <div v-for="(campo,index) in camposDelFormulario" :key="index">

                <div class="caja-formulario" v-if="campo.tipo==1">
                      <h6>{{campo.Nombre}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text"  :id="campo.model" :class="'form-control campo'" placeholder="Ingrese Información" @keyup="llenarFormulario() "/>
        </div>
        <div class="caja-formulario" v-if="campo.tipo==2">
            <h6>{{campo.Nombre}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
            <Datepicker :id="campo.model" :value="fechaNacimiento" :language="es" :input-class="'form-control'" format="dd-MM-yyyy"></Datepicker>
          </div>  
                
         <div class="caja-formulario" v-if="campo.tipo==7">
                      <h6>{{campo.Nombre}}<label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="campo.model" :class="'form-control campo'"  placeholder="Ingrese clave única de registro de población" @keyup="llenarFormulario()" maxlength="21"/>
        </div>
        <div class="caja-formulario" v-if="campo.tipo==4">
                    <h6>{{campo.Nombre}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="tel" :id="campo.model" :class="'form-control campo'" maxlength="14" placeholder="Ingrese número telefónico" @keyup="llenarFormulario()" @keypress="formateoTelefono(campo.model)" @blur="formateoTelefono(campo.model)"/>
        </div>
        <div v-if="campo.tipo==5">        
            <div class="caja-formulario" >
                      <h6>{{campo.Nombre}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="campo.model" class="form-control campo" :class="claseCssParaEmail" onpaste="return false" autocomplete="off"  placeholder="Ingrese correo electrónico" @keyup="validarCorreosElectronicos " />
        </div>
        <div class="caja-formulario">
                      <h6>Confirma {{campo.Nombre}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <input type="text" :id="campo.model+'confirma'" class='form-control campo date' :class="claseCssParaEmail" onpaste="return false" autocomplete="off" placeholder="confirme su correo electrónico" @keyup="validarCorreosElectronicos" />
        </div>
        </div>
        <div class="caja-formulario" v-if="campo.tipo==3">
                      <h6>{{campo.Nombre}} <label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
                    <select :id="campo.model" :class="'form-control select-estilos'" @change="llenarFormulario()">
                    <option selected value="">Seleccione una Opcion</option>
                    <option v-for="(opcion,i) in campo.selects" :value="opcion.index" :key="i">{{opcion.opcion}}</option>
                    <!-- <option value="2">Casado</option> -->
                    </select>
        </div>
        <div class="caja-formulario" v-if="campo.tipo==8">
            <h6>{{campo.Nombre}}<label v-if="campo.Requerido" class="asterisco-requerido">(*)</label></h6>
            <textarea type="text" :id="campo.model" :class="'form-control campo'" placeholder="Ingrese texto" @keyup="llenarFormulario()"></textarea>        
        </div>
    </div>


       



        
    </div>
<div v-show="mostrarInformacion==false">

<div v-for="(campo,index) in camposDelFormulario" :key="index">
    <div class="caja-formulario" v-if="campo.tipo==6">
            <h6>{{campo.Nombre}}: <label v-if="campo.Requerido"  class="asterisco-requerido">(*)</label></h6>
            <input type="file" :id="campo.model" :class="'form-control select-estilos'" accept="application/pdf" @change="cargarDocumento($event,campo.model)" />
    </div>
</div>

</div>
    </div>
    <div class="botones-guardar">
        <button class="btn btn-danger boton-general"  v-if="mostrarBtnGuardar" @click="guardarInformacionAspirante()">GUARDAR</button>
        <button class="btn btn-success boton-general" v-if="!mostrarBtnGuardar"  @click="mostrarInformacion=!mostrarInformacion">CONTINUAR LLENADO</button>
     
    </div>
</div>
         <!-- MODAL CON VISUALIZADOR DE REPORTE -->
    <div class="modal align-middle" tabindex="-1" data-backdrop="static" data-keyboard="false"  id="visualizador-documento">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reporte generado</h5>
                        <button id="btn-cerrar-visualizador-reporte-notificador-asignaciones" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body pl-4 pr-4">
                        <PDFDocument 
                            :url="documento.url" 
                            :ArchivoAConvertir=null
                            :EsBase64="EsBase64"
                            :EsBlob = "EsBlob"
                            :height="documento.height"
                            :key="'VACANOT' + documento.contRender" />
                    </div>
                    <button class="btn btn-success" @click="aceptarDocumento">Aceptar</button>           
                </div>
            </div>
        </div>
    </div>

    <div v-if="!convocatoriaEncontrada" class="convocatoria-noencontrada">
        <img class="imagen-nofound" src="https://themisfsweb.poderjudicialags.gob.mx/SICPO/ImagenesPortal/alert.png" alt="Convocatoria no encontrada"><br>
    <label>
        Lo sentimos, la convocatoria no existe o ya ha caducado 
    </label>
    </div>
</div>

</template>

<script>
import axios from "axios"
import api from '@/../static/js/api'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'
import PDFDocument from '@/../src/components/Comunes/PDFDocument'



export default {
   
    props:{
        seccionDeLaPaginaWeb:Object
    },
    components:{
        Datepicker,
        PDFDocument
    },
    data() {
        return{
        es: es,
        documento:{
            url:"",
            archivoDeReporte:"",
            height: '750px',
            contRender:1
        },
        EsBase64:false,
        EsBlob : {
            esBlob:true,
            blob:null
        },
        IdFormulario:0,
        convocatoriaEncontrada:false,
        nombreConvocatoria:null,
        fechaActual:new Date(),
        camposDelFormulario:[],
        mostrarInformacion:true,
        mostrarBtnGuardar:false,
        correoValidado:false,
        claseCssParaEmail:'',
        fechaNacimiento:new Date(),
      
        }
    },
    methods:{

        llenarFormulario:async function(){
            console.log("v-modelo::::",$("#Nombre_Aspirante0").val())
         

            this.camposDelFormulario.map(e=>{
                let contenido = e
                let valor = $('#'+contenido.model).val()
               // if(contenido.Requerido){
                    if(contenido.tipo != 6){
                        contenido.valor = $('#'+contenido.model).val();        
                    }

                  //  else contenido.valor = null;
                //}
            });

            console.log("jsonLLeno::",this.camposDelFormulario)
            this.validarFormularioRequerido();
        },
validarFormularioRequerido:function(){ 
    
    let camposRequeridosLLenos = true;
    this.camposDelFormulario.map(e=>{
    let contenido = e
        if(contenido.Requerido){
            console.log("entra::::")
            if(contenido.valor=="" || contenido.valor==null){
                console.log("entra al if:::",contenido)
                camposRequeridosLLenos = false;           
            }
            if(contenido.tipo==5 && !this.correoValidado){
                camposRequeridosLLenos = false;
            }
        }
    });
console.log("validando::",camposRequeridosLLenos)
this.mostrarBtnGuardar = camposRequeridosLLenos;
},

        guardarInformacionAspirante:async function(){


            let dialog = bootbox.dialog({
                                message: '<div style="text-align:center"><i class="fas fa-spinner fa-spin" style="color:#09BCEC;font-size:3em"></i><br> <p style="font-size:2em" class="text-center mb-0"> Por favor espere mientras procesamos la información.</p></div>',
                                closeButton: false
                                });

            const SERVIDOR = api.conexion;             
            const METODO_API_AGREGAR = api.SICPO.sistema.paginaweb.convocatoriasWeb.GuardarAsistenteAConvocatoria;
            const END_POINT = SERVIDOR+METODO_API_AGREGAR;
             return axios.post(END_POINT, this.crearPeticion()).then(async response => {
                console.log("respuesta:::",response)
                dialog.modal('hide');
                if(response.data.SiHayError){
                    dialog.modal('hide');
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-exclamation-triangle" style="color: #e10909;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Lo sentimos!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Ha ocurrido un error mientras se procesaba la información, por favor intente más tarde.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Cerrar",
                                className: 'btn-danger',
                            }
                        }
                    });
                               
                }else{
                
                   // dialog.modal('hide');
                  
                    bootbox.dialog({                  
                                message: '<div style="text-align:center"><i class="fas fa-check-circle" style="color: #07cf9d;font-size:3em"></i><br><p style="font-size:2em" class="text-center mb-0">¡Felicidades!</p> <br> <p style="font-size:2em" class="text-center mb-0"> Su registro ha sido exitoso, el folio de su solicitud es '+response.data.folioAspirante+' además se le ha enviado un correo de confirmación a la dirección especificada.</p></div>',
                                buttons: {
                                cancel: {
                                label: "Entendido",
                                className: 'btn-info',
                                }
                        }
                    });
                    this.limpiarFormulario();
                    
                }
             }).catch(e => {
                dialog.modal('hide');
                console.log("A sucedido un error en el sistema::",e.message);
             });
        
        },
        crearPeticion:function(){
            var bodyFormData = new FormData();
            this.camposDelFormulario.map(cont=>{
                let contenido = cont          
                    if(contenido.tipo == 6 && contenido.valor!="" && contenido.valor!=null){                       
                        bodyFormData.append(contenido.model,contenido.valor);        
                        contenido.valor = "Documento";
                    }
            });
            bodyFormData.append('Aspirante',JSON.stringify(this.camposDelFormulario));
            bodyFormData.append('NombreConvocatoria',this.nombreConvocatoria);
            bodyFormData.append('IdFormulario',this.IdFormulario);
            bodyFormData.append('EsPrueba',false);

            return bodyFormData;
        },
        cargarDocumento:function(e,tipoDocumento){
                console.log("DOCUMENTO::",e.target.files[0])
                console.log("tipopopopo::::",tipoDocumento)

                this.camposDelFormulario.map(cont=>{
                let contenido = cont              
                    if(contenido.tipo == 6 && contenido.model == tipoDocumento){
                        contenido.valor = e.target.files[0];
                        if(contenido.valor!=undefined && contenido.valor != null) 
                        this.convierteDocumentoABlob(e.target.files[0]);       
                    }
                
            });

            console.log("jsonLLenoDocumentos::",this.camposDelFormulario)
            this.validarFormularioRequerido();
             
        },
        convierteDocumentoABlob:function(documento){
            documento.arrayBuffer().then((arrayBuffer) => {
            const blob = new Blob([new Uint8Array(arrayBuffer)], {type: documento.type });
            this.EsBlob.blob = blob;
            this.documento.contRender++;
            $('#visualizador-documento').modal('show'); 
            console.log('blob',blob);
            });

        },
        aceptarDocumento:function(){
            $('#visualizador-documento').modal('hide'); 
        },
       
        validarCorreosElectronicos:function(){
           this.correoValidado = false
           this.camposDelFormulario.filter(s => s.tipo==5).map(cont => {
           
            let correo = $('#'+cont.model).val();
            let correoConfirma = $('#'+cont.model+'confirma').val();

            if(correo!=null && correoConfirma!=null && correo !="" && correoConfirma!="" ){
                console.log("entravalidacionde correos",correo)
                console.log("entravalidacionde correoConfirma",correoConfirma)
                if(correo.toLowerCase() == correoConfirma.toLowerCase() && correo.includes('@') && correoConfirma.includes('@')){
                    this.claseCssParaEmail = 'correo-valido';
                    this.correoValidado=true;
                }else{
                    this.claseCssParaEmail = 'correo-invalido';
                }
             } 

           });
           this.llenarFormulario();
              
        },

        limpiarFormulario:function(){         
            this.fechaNacimiento=new Date();         
            this.mostrarBtnGuardar=false;
            this.claseCssParaEmail='';
            this.correoValidado=false;
            this.camposDelFormulario.map(cont => {
                if(cont.tipo==2) $('#'+cont.model).val(new Date());
                else{
                    $('#'+cont.model).val("");
                }

                if(cont.tipo==5) $('#'+cont.model+'confirma').val("");
            })

        },

        CrearFormulario:function(){

            const SERVIDOR = api.conexion;             
            const METODO_API = api.SICPO.sistema.paginaweb.convocatoriasWeb.ObtenerFormularioPorId;
            const END_POINT = SERVIDOR+METODO_API;
            console.log("CONSOLEcONOVATORIAS::::", this.$route.query)
             return axios.post(END_POINT, {"IdFormulario": this.$route.query.folio}).then(async response => {
                console.log("respuesta:::",response.data)
                if(response.data.SiHayError || response.data.Convocatoria == 0){
                    this.convocatoriaEncontrada = false;
                                                   
                }else{
                   this.convocatoriaEncontrada = true;
                   this.camposDelFormulario = response.data.Json.map((c,i) => {
                    let contenido = c
                    contenido.model = contenido.Nombre.replaceAll(" ","_")+i
                    return contenido;
                   }); 
                   this.nombreConvocatoria = response.data.NombreConvocatoria;
                   this.IdFormulario = response.data.Idformulario;
                   
                   console.log("JsonModificaco:::", this.camposDelFormulario )
                }}).catch(e => {
                console.log("A sucedido un error en el sistema::",e.message);
             });
        


        },
        formateoTelefono:function(elemento){
            console.log("inputId:::",elemento);
            let telefono = $('#'+elemento).val();
            if (telefono != "")
            { 
                var numeros = telefono.replace(/\D/g, ''),
                char = {0:'(',3:') ',6:'-'};
                telefono = '';
                    let upto = numeros.length; 
                    if(numeros.length < 10) 
                    { 
                        upto = numeros.length; 
                    }
                    else
                    { 
                        upto = 10; 
                    }
                    for (var i = 0; i < upto; i++) {
                        telefono += (char[i]||'') + numeros[i];
                    }
            }
            
            console.log("formato telefono::",telefono)
            $('#'+elemento).val(telefono);

        }
        

      


    },
    mounted(){
       
        this.CrearFormulario();

    }

}
</script>
<style scoped>
.imagen-nofound{
    width: 30%;
}
.convocatoria-noencontrada{
 width: 100%;
 height: 50%;
 text-align: center;
 color: #c90f08;
 font-size: 3em;
 margin-top: 3em;
 border-radius: 25% 10%;
}
    .caja-formulario{
        margin-left: 10em;
        margin-right: 10em;
        margin-bottom: 1.5em !important;
        display: block !important;
        color:black
    }
    .caja-principal{
         /* background-color: red;  */
        padding-left: 10em;
        padding-right: 10em;
        padding-bottom: 5em;

    }
    .caja-contenedora-formulario{
        /* background-color: blue; */
        border-color: black;
        padding-block: 2em;
        padding-bottom: 4em;
        border-radius: 25px;
        box-shadow: 0px 0px 30px rgb(188, 188, 189);
    }
    .campo{
        background-color: #e3e2e7;
    border: none;
    color:  #6c757d;
    text-transform: uppercase;
  

    }
    textarea.campo{
      height: 8em;
    }
    .asterisco-requerido{
        color: rgb(228, 3, 3);
    }
    .select-estilos{
        background-color: #e3e2e7;
        color: #6c757d;
    }
    .pestanas{
       
        margin-bottom: 4em;
        text-align: center;
        border:solid 1px #ced0d1;
        border-radius: 5px;
        padding: .5em;
        
    }
    .boton-pestana{
        width: 40%;
    }
    .botones-guardar{
        text-align: center;
    }
    .boton-general{
        width: 15em;
    }
    .mensaje-procesando{
        font-size: 5em;
    }
    .correo-valido{
        border:solid 1px #05c484;
    }
    .correo-invalido{
        border:solid 1px #c90f08;
    }

    .page-title {
    background-color: rgb(50,50,50);
    color: #FFF;
    padding: 2vh 20vw;
    text-align: center;
    border-top: solid white 15px;

  }

  @media (max-width: 600px) {
    .page-title{
      font-size: 2em;
    }

    h2{
      font-size: 1.8em;
    }
  }



</style>
<style>
    #fecha-nacimiento-convocatoriaweb{
    color:  #6c757d;
    font-size: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/PaginaOficial/PaginaInformativa/Convocatorias/ConvocatoriasFormulario.vue